import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-markup";
import "prismjs/themes/prism.css";

import { MODES } from "./constants";

const style = {
  fontFamily: '"Fira code", "Fira Mono", monospace',
  fontSize: 12,
};

const highlightFn = (code) => highlight(code, languages.markup);

export const Edit = ({ mode, editorState, onEditorStateChange }) => {
  if (mode !== MODES.EDIT) {
    return null;
  }

  return (
    <Editor
      value={editorState}
      onValueChange={onEditorStateChange}
      highlight={highlightFn}
      padding={10}
      style={style}
    />
  );
};
